import axios from 'axios'
import moment from 'moment'
export default class Service {
  constructor() {
    this.urlBase = process.env.VUE_APP_URL_API_BASE
    this.urlRecursoAPI = 'rest/app/app'
    this.urlRecursoWeb = 'web'
  }

  getRequisicaoPadrao(payload, method, programa = '') {
    var iCodPessoa = parseInt(localStorage.getItem('codPessoa'))
    var validaSenha = ''

    if (iCodPessoa > 0) {
      validaSenha = {codPessoa: iCodPessoa,
                     hash:  localStorage.getItem("hash")}
    }

    var send = {
      uid: '',
      pwd: '',
      ptoP: programa == '' ? 'admin/colaborador.p' : programa,
      params: [
        {
          parametro: 'pcValidaSenha',
          data_type: 'char',
          param_type: 'input',
          valor: JSON.stringify(validaSenha),
        },
        {
          parametro: 'pcMetodo',
          data_type: 'char',
          param_type: 'input',
          valor: method,
        },
        {
          parametro: 'pcParametros',
          data_type: 'longchar',
          param_type: 'input',
          valor: payload,
        },
        {
          parametro: 'pcRetorno',
          data_type: 'longchar',
          param_type: 'output',
          valor: '',
        },
      ],
    }

    return axios.put(this.urlBase + '/' + this.urlRecursoAPI, send)
  }

  buscaImagemPerfil() {
    return localStorage.getItem('codPessoa')
      ? this.urlBase +
      '/' +
      this.urlRecursoWeb +
      '/' +
      'DownloadUploadFiles?tabela=pessoa&campo=imagem&chave=' +
      parseInt(localStorage.getItem('codPessoa')) +
      '%7C'
      : ''
  }

  validaCPF(payload) {
    return this.getRequisicaoPadrao(JSON.stringify(payload), 'validaCPF')
  }

  validaSenha(payload) {
    return this.getRequisicaoPadrao(JSON.stringify(payload), 'validaSenha')
  }

  buscaMovimento(payload) {
    return this.getRequisicaoPadrao(JSON.stringify(payload), 'buscaMovimento')
  }

  getCidadeCEP(cep) {
    return axios.get('https://viacep.com.br/ws/' + cep + '/json/unicode/')
  }

  getAnualIncomeReport(payload) {
    return this.getRequisicaoPadrao(JSON.stringify(payload), 'decRendimento')
  }

  buscaDadosPessoais(payload) {
    return this.getRequisicaoPadrao(
      JSON.stringify(payload),
      'buscaDadosCadastrais'
    )
  }

  buscaDadosContratuais(payload) {
    return this.getRequisicaoPadrao(
      JSON.stringify(payload),
      'buscaDadosContratuais'
    )
  }

  buscaCompetencia(payload) {
    return this.getRequisicaoPadrao(JSON.stringify(payload), 'buscaCompetencia')
  }

  buscarAvisos(payload) {
    return this.getRequisicaoPadrao(JSON.stringify(payload), 'buscaAviso')
  }

  alteraSituacaoAviso(payload) {
    return this.getRequisicaoPadrao(
      JSON.stringify(payload),
      'alteraSituacaoAviso'
    )
  }

  buscaAnexo(codEmp, codEmpregado, codAviso, sequencia, dtAviso, seqAnexo) {
    //return `${this.urlBase}/${this.urlRecursoWeb}/DownloadUploadFiles?tabela=empAviso&campo=anexo&chave=${codEmp}|${codEmpregado}|${codAviso}|${sequencia}|${dtAviso}|${seqAnexo}&usuario=mestre&senha=Mariana23`
    const url = encodeURI(
      `${this.urlBase}/${this.urlRecursoWeb}/DownloadUploadFiles?tabela=empAviso&campo=anexo&chave=${codEmp}|${codEmpregado}|${codAviso}|${sequencia}|${dtAviso}|${seqAnexo}&usuario=mestre&senha=Mariana23`
    )
    return url
  }

  getPublicPlaces() {
    return this.getRequisicaoPadrao('', 'buscaLogradouro')
  }

  buscaUfs() {
    return this.getRequisicaoPadrao('', 'gerauf')
  }

  getMaritalStates() {
    return this.getRequisicaoPadrao('', 'geraestadocivil')
  }

  getLevelsOfEducation() {
    return this.getRequisicaoPadrao('', 'geragrauinstrucao')
  }

  buscarDependentes(payload) {
    return this.getRequisicaoPadrao(JSON.stringify(payload), 'buscaDependentes')
  }

  buscarDependencia() {
    return this.getRequisicaoPadrao('', 'buscaDependencia')
  }

  buscarTiposNecessidades() {
    return this.getRequisicaoPadrao('', 'buscaTipoNecessidade')
  }

  verificaCadastroPendente(payload) {
    return this.getRequisicaoPadrao(JSON.stringify(payload), 'buscaWebPessoa')
  }

  gravarDadosCadastrais(dadosCadastrais) {
    return this.getRequisicaoPadrao(
      '{"ttWebPessoa": [ ' + JSON.stringify(dadosCadastrais) + ' ]}',
      'gravaWebPessoa'
    )
  }

  gravarDependente(dependente) {
    return this.getRequisicaoPadrao(
      '{"ttWebDependente": [ ' + JSON.stringify(dependente) + ' ]}',
      'gravaWebDependente'
    )
  }  

  alterarSenha(senha, codPessoa) {
    return this.getRequisicaoPadrao(
      '{"senha": "' + senha.toString() + '", "codPessoa":' + codPessoa + '}',
      'alterasenha',
      'admin/colaborador.p'
      //"admin/weadmrh026.p"
    )
  }
  alterarSenhaLogin(senha, codPessoa) {
    return this.getRequisicaoPadrao(
      '{"senha": "' + senha.toString() + '", "codPessoa":' + codPessoa + '}',
      'alterasenha'
    )
  }
  excluirWebPessoa(data) {
    return this.getRequisicaoPadrao(
      `{"codPessoa": ${parseInt(localStorage.getItem('codPessoa'))}` +
      ', "dtMovto":"' +
      data +
      '"}',
      'excluirWebPessoa'
    )
  }

  excluirWebDependente(sequencia) {
    return this.getRequisicaoPadrao(
      `{"codPessoa": ${parseInt(localStorage.getItem('codPessoa'))}` +
      ', "sequencia":' +
      sequencia +
      '}',
      'excluirWebDependente'
    )
  }

  uploadImagem(arquivo, sequencia) {
    var formData = new FormData()
    formData.append('files', arquivo)

    return axios.post(
      this.urlBase +
      `/web/DownloadUploadFiles?tabela=webDependente&campo=${localStorage.getItem(
        'codPessoa'
      )}&chave=${localStorage.getItem('codPessoa')}${sequencia}&usuario=${process.env.VUE_APP_URL_API_USER
      }&senha=${process.env.VUE_APP_URL_API_PASS}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
  }

  uploadImagemAtualizacaoCadastral(arquivo, data) {
    var formData = new FormData()
    formData.append('files', arquivo)

    const url = encodeURI(
      this.urlBase +
      `/web/DownloadUploadFiles?tabela=webPessoa&campo=anexo&chave=${localStorage.getItem(
        'codPessoa'
      )}|${data}`
    )

    return axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  uploadAnexoFaleComRH(arquivo, data) {
    var formData = new FormData()
    formData.append('files', arquivo)

    const url = encodeURI(
      this.urlBase +
      `/web/DownloadUploadFiles?tabela=avisoRh&campo=anexo&chave=${localStorage.getItem(
        'codPessoa'
      )}|${data}`
    )

    return axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  //Recuperação de Senha
  esqueceuSenha(cod) {
    return this.getRequisicaoPadrao(
      '{"codpessoa":' + cod + '}',
      'esqueceusenha',
      'admin/colaborador.p'
      //"admin/weadmrh026.p"
    )
  }

  enviaWhatsApp(cod, telefone) {
    return this.getRequisicaoPadrao(
      '{"codpessoa":' + cod + ', "telefone": "' + telefone + '"}',
      'enviaWhatsApp',
      'admin/colaborador.p'
      //"admin/weadmrh026.p"
    )
  }

  enviaEmail(cod, email) {
    return this.getRequisicaoPadrao(
      '{"codpessoa":' + cod + ', "email": "' + email + '"}',
      'enviaemail',
      'admin/colaborador.p'
      //"admin/weadmrh026.p"
    )
  }

  getObservacao(payload) {
    return this.getRequisicaoPadrao(JSON.stringify(payload), 'buscaObservacao')
  }

  getAnosParaRendimentos(payload) {
    console.log(payload)
    return this.getRequisicaoPadrao(
      JSON.stringify(payload),
      'buscaAnoRendimento'
    )
  }

  getBeneficios() {
    const codPessoa = parseInt(localStorage.getItem('codPessoa'))
    return this.getRequisicaoPadrao(
      JSON.stringify({ codPessoa: codPessoa }),
      'buscaBeneficio'
    )
  }

  getBeneficiosDependentes(codDependente) {
    const codPessoa = parseInt(localStorage.getItem('codPessoa'))
    return this.getRequisicaoPadrao(
      JSON.stringify({ codPessoa: codPessoa, codDependente: codDependente }),
      'buscaPSaudeDependente'
    )
  }

  buscaIndicaPip() {
    const codPessoa = parseInt(localStorage.getItem('codPessoa'))
    return this.getRequisicaoPadrao(
      JSON.stringify({ codPessoa: codPessoa, ano: moment().format('YYYY') }),
      'buscaIndicaPip'
    )
  }

  getPeriodosEspelhoPonto() {
    const codPessoa = parseInt(localStorage.getItem('codPessoa'))
    return this.getRequisicaoPadrao(
      JSON.stringify({ codPessoa: codPessoa }),
      'buscaPeriodo'
    )
  }

  getCartaoPonto(codPeriodo) {
    const codPessoa = parseInt(localStorage.getItem('codPessoa'))
    return this.getRequisicaoPadrao(
      JSON.stringify({ codPessoa: codPessoa, codPeriodo: codPeriodo }),
      'buscaCartaoPonto'
    )
  }

  getPlanoSaude(mes, ano) {
    const codPessoa = parseInt(localStorage.getItem('codPessoa'))
    return this.getRequisicaoPadrao(
      JSON.stringify({ codPessoa: codPessoa, mes: mes, ano: ano }),
      'buscaPlanoSaude'
    )
  }

  getVarejo(mes, ano) {
    const codPessoa = parseInt(localStorage.getItem('codPessoa'))
    return this.getRequisicaoPadrao(
      JSON.stringify({ codPessoa: codPessoa, mes: mes, ano: ano }),
      'buscaVarejo'
    )
  }
  async getBuscaAgenda() {
    const codPessoa = parseInt(localStorage.getItem('codPessoa'))

    let response = await this.getRequisicaoPadrao(
      JSON.stringify({ codPessoa: codPessoa }),
      'buscaAgenda'
    )

    return response.data?.ttAgendaAvaliacao ?? response.data.retorno[0]
    //return this.getRequisicaoPadrao(JSON.stringify({ codPessoa: codPessoa }), "buscaAgenda")
  }
  async getBuscaQuestionario(cod) {
    const codQuestionario = parseInt(cod)

    const response = await this.getRequisicaoPadrao(
      JSON.stringify({ codQuestionario: codQuestionario }),
      'buscaQuestionario'
    )

    return response.data?.questionario?.ttQuestionario?.[0] ?? {}

    //return this.getRequisicaoPadrao(JSON.stringify({ codPessoa: codPessoa }), "buscaAgenda")
  }
  async gravaPessoaAvaliacao(payload) {
    const response = await this.getRequisicaoPadrao(
      JSON.stringify({ ttPessoaAvaliacao: payload }),
      'gravaPessoaAvaliacao'
    )
    return response.data.retorno[0].msgErro
  }

  async buscaTipoAviso() {
    const codPessoa = parseInt(localStorage.getItem('codPessoa'))
    let response = await this.getRequisicaoPadrao(
      JSON.stringify({ codPessoa: codPessoa }),
      'buscaTipoAviso'
    )
    return response.data?.tipoAviso ?? []
  }

  async buscaMarcacaoPonto(tipo) {
    const codPessoa = parseInt(localStorage.getItem('codPessoa'))
    let response = await this.getRequisicaoPadrao(
      JSON.stringify({ codPessoa: codPessoa ,
                       tipo:      tipo}),
      'buscaMarcacaoPonto'
    )
    return response.data?.Marcacao ?? []
  }

  async gravaAvisoRH(codTipo, descricao) {
    const codPessoa = parseInt(localStorage.getItem('codPessoa'))
    await this.getRequisicaoPadrao(
      JSON.stringify({
        codPessoa: codPessoa,
        codTipo: codTipo,
        descricao: descricao,
      }),
      'gravaAvisoRH'
    )
  }

  getStatusVarejo() {
    const codPessoa = parseInt(localStorage.getItem('codPessoa'))
    const mes = moment().month()
    return this.getRequisicaoPadrao(
      JSON.stringify({ codPessoa: codPessoa, mes: mes + 1, ano: 2022 }),
      'buscaPedido'
    )
  }

  buscaItensDoVarejo() {
    const codPessoa = parseInt(localStorage.getItem('codPessoa'))
    const mes = moment().month()
    return this.getRequisicaoPadrao(JSON.stringify({ codPessoa: codPessoa, mes: mes + 1, ano: 2022 }), 'buscaItensDoVarejo')
  }

  gravaItensDoVarejo(itens) {
    return this.getRequisicaoPadrao(JSON.stringify({ ttPedidoVarejoItem: itens }), 'gravaItensDoVarejo')
  }

  async buscaCartilha() {
    const iCodPessoa = parseInt(localStorage.getItem('codPessoa'))
    let response = await this.getRequisicaoPadrao(JSON.stringify({ codPessoa: iCodPessoa}), 'buscaCartilha')
    return response.data?.ttCartilha ?? []
  }

  async buscaProgramacaoFerias() {
    const codPessoa = parseInt(localStorage.getItem('codPessoa'))
    let response = await this.getRequisicaoPadrao(JSON.stringify({
      codPessoa: codPessoa,}), 'buscaProgramacaoFerias')
    return response.data?.ttFeriasPrograma ?? []
  }

  async buscaDocumentos(payload) {
    let response = await this.getRequisicaoPadrao(JSON.stringify(payload), 'buscaDoctoAssinado')
    return response.data?.ttDoctoAssinado ?? []
  } 

  buscaParametro() {
    const codPessoa = parseInt(localStorage.getItem('codPessoa'))
    return this.getRequisicaoPadrao(JSON.stringify({codPessoa: codPessoa,}), 'buscaParametroColab')
  }

  async buscaTotPontoCalculado(tipo) {
    const codPessoa = parseInt(localStorage.getItem('codPessoa'))
    let response = await this.getRequisicaoPadrao(
      JSON.stringify({ codPessoa: codPessoa ,
                       tipo:      tipo}),
      'buscaTotPontoCalculado'
    )
    return response.data?.pontoCalculado ?? []
  }

  async buscarMarcacaoAjuste() {
    const codPessoa = parseInt(localStorage.getItem('codPessoa'))
    let response = await this.getRequisicaoPadrao(
      JSON.stringify({ codPessoa: codPessoa }),
      'buscaMarcacaoAjuste'
    )
    return response.data?.ttPontoHora ?? []
  }

  async salvaAjusteMarcacao(payload) {
    const codPessoa = parseInt(localStorage.getItem('codPessoa'))
    let response = await this.getRequisicaoPadrao(
      JSON.stringify({ codPessoa: codPessoa,
                       dtMovto: payload.dtMovto,
                       segMovto: payload.segMovto,
                       observacao: payload.observacao }),
      'gravaMarcacaoAjuste'
    )
    return response.data?.retorno
  }

  async buscarOportunidadesInternas() {
    let response = await this.getRequisicaoPadrao(
      JSON.stringify({ }),
      'geraRequisicaoInterna'
    )
    return response.data?.ttRequisicao ?? []
  }

  async candidatarVaga(payload) {
    const codPessoa = parseInt(localStorage.getItem('codPessoa'))
    let response = await this.getRequisicaoPadrao(
      JSON.stringify({ codPessoa: codPessoa,
                       codRequisicao: payload.codRequisicao }),
      'candidatarParaVaga'
    )
    return response.data?.retorno
  }  

  async buscaAvisoRH(payload) {
    const response = await this.getRequisicaoPadrao(JSON.stringify(payload), 'buscaAvisoRH')
    return response.data?.AvisoRH ?? []
  }

  async buscaCardapio() {
    const codPessoa = parseInt(localStorage.getItem('codPessoa'))
    let response = await this.getRequisicaoPadrao(
      JSON.stringify({ codPessoa: codPessoa }),
      'buscaCardapio'
    )
    return response.data?.ttCardapioData ?? []
  }  

  async gravaReserva(payload) {
    const codPessoa = parseInt(localStorage.getItem('codPessoa'))
    let response = await this.getRequisicaoPadrao(
      JSON.stringify({ codPessoa: codPessoa,
                       dtCardapio: payload.dtCardapio,
                       codCardapio: payload.codCardapio,
                       substProteina: payload.substProteina}),
      'gravaReservaRestaurante'
    )
    return response.data?.retorno
  }  

  getValeRefeicao(payload) {
    return this.getRequisicaoPadrao(JSON.stringify(payload), 'buscaValeRefeicaoRica')
  }
}